import { Order_Status_Enum } from '@kheops/graphql';
import { useMemo } from 'react';
import { useGetOrdersHistoryByContractQuery } from '../queries/__generated__/getOrdersHistoryByContract.generated';

interface UseGetValidatedOrdersOnFIrstTryCountProps {
  buyerCompanyId: string;
  supplierCompanyId: string;
}

interface OrderHistory {
  id: string;
  reference_id: string;
  status: Order_Status_Enum;
  created_at: string;
}

export default function useGetValidatedOrdersOnFirstTryCount({ buyerCompanyId, supplierCompanyId }: UseGetValidatedOrdersOnFIrstTryCountProps): number {
  const { data } = useGetOrdersHistoryByContractQuery(
    {
      variables: {
        supplyingCompanyId: supplierCompanyId,
        buyingCompanyId: buyerCompanyId,
      },
    },
  );

  const validatedOnFirstTryCount = useMemo(() => {
    if (!data?.order_history.length) {
      return 0;
    }

    const ordersGroupedByRefId = data?.order_history.reduce<Record<string, OrderHistory[]>>((acc, entry) => {
      if (!acc[entry.reference_id]) {
        acc[entry.reference_id] = [];
      }

      acc[entry.reference_id].push(entry);

      return acc;
    }, {});

    const firstValidationCount = Object.keys(ordersGroupedByRefId).reduce((count, referenceId) => {
      const orderSteps = ordersGroupedByRefId[referenceId];
      const firstStep = orderSteps[0];
      const secondStep = orderSteps[1];

      if (secondStep
          && firstStep.status === Order_Status_Enum.OrderToBeValidatedByBuyer
          && (secondStep.status === Order_Status_Enum.OrderToBeDeliveredBySupplier || secondStep.status === Order_Status_Enum.OrderToBePreparedBySupplier)
      ) {
        return count + 1;
      }

      return count;
    }, 0);

    return firstValidationCount;
  }, [data]);

  return validatedOnFirstTryCount;
}
